import { apiClient, unwrap } from '@/lib/api-client';
import type { ApiSuccess } from '@/types/api';
import type { PlatformStats, PlatformStorageReport, TrialStats } from '@/types/platform';

export const statsService = {
  getPlatformStats(): Promise<PlatformStats> {
    return unwrap(apiClient.get<ApiSuccess<PlatformStats>>('/admin/stats/platform'));
  },

  getStorageReport(): Promise<PlatformStorageReport> {
    return unwrap(apiClient.get<ApiSuccess<PlatformStorageReport>>('/admin/stats/storage'));
  },

  /** Kosongkan `endsFrom`/`endsTo` untuk seluruh lembaga yang pernah diberi uji coba. */
  getTrialStats(params: { endsFrom?: string; endsTo?: string } = {}): Promise<TrialStats> {
    return unwrap(apiClient.get<ApiSuccess<TrialStats>>('/admin/stats/trial', { params }));
  },
};
